import { authProvider, AxiosProvider } from "../config/axiosProvider.ts";
import { ContactForm } from '../types/contactType.ts';
import { BotTrapFields } from "@common/types/botTrapTypes.ts";

class ContactService {

    constructor(private readonly api: AxiosProvider) {}

    postFormContact = async (contactForm: ContactForm, botTrap: BotTrapFields) => {
        return await this.api.getApi().post("/api/contact", { contactForm, ...botTrap }).then(res => res);
    };

}

export default new ContactService(authProvider);
